export class APIError extends Error {
  code = 0;
  message = "";
  data?: string = undefined;

  constructor(code: number, message: string, data: string | undefined) {
    super();
    this.code = code;
    this.message = message;
    this.data = data;
  }
}

export interface APIRequest {}

export interface APIResponse<T> {
  code: number;
  message: string;
  data?: T;
}
